module.exports = __webpack_public_path__ + "static/media/成功@2x.209c8.png";